import { createContext, useEffect, useReducer } from "react";
import DarkModeReducer from "./darkModeReducer";
const INITIAL_STATE = {
  darkMode: localStorage.getItem("darkMode") === "true",
};

export const DarkModeContext = createContext(INITIAL_STATE);

export const DarkModeContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(DarkModeReducer, INITIAL_STATE);

  useEffect(() => {
    localStorage.setItem("darkMode", String(state.darkMode));
  }, [state.darkMode]);

  return (
    <DarkModeContext.Provider value={{ darkMode: state.darkMode, dispatch }}>
      {children}
    </DarkModeContext.Provider>
  );
};
